import { resolver } from '../generated/tokens.js'

const tokens = resolver.apply({})
const tokenValue = (id) => tokens[id].$value

const valuesByName = (prefix, names, select = (value) => value) =>
  Object.freeze(
    Object.fromEntries(names.map((name) => [name, select(tokenValue(`${prefix}.${name}`))]))
  )

export const brandColors = valuesByName(
  'color.brand',
  ['base', 'hover', 'pressed', 'lifted', 'patina'],
  (value) => value.hex
)

export const motionDurationsMs = valuesByName(
  'motion.duration',
  ['instant', 'fast', 'normal', 'slow', 'entrance'],
  (value) => value.value
)

export const motionEasings = valuesByName('motion.easing', ['drawer', 'out', 'spring'], (value) =>
  Object.freeze(value)
)
